// MULTI-IMPACT - Exade Partenaires
// Fonctions generiques Javascript
// NOMFICHIER : Script_FonctionsGenerales_Entete.js

// Surligne l'element "nomObjet" si onOff=true, en blanc si onOff=false
function marquerErreur(nomObjet, onOff) {
    var objet = document.getElementById(nomObjet);
    if (objet != null) {
        // objet.style.backgroundColor= onOff ? '#F55A5A' : 'white';
        // var $objet = $('#' + nomObjet).closest('.form-group');
        var $objet = $('#' + nomObjet);
        if (onOff)
            $objet.addClass('is-invalid');
        else
            $objet.removeClass('is-invalid');
    }
}

/* controleDate(id du champ jour, message d'erreur, obligatoire)
Exemple : si le champ a pour id "vtJourDate", la fonction controle vtJourDate puis vtMoisDate et vtAnneeDate et renvoie le message d'erreur en cas de probleme
Si "obligatoire" est a  true, la fonction considere que le champ date est obligatoire.
On peut passer un quatrieme parametre non defini dans le prototype de la fonction : controlePostDateJour : si il est a  True,
la fonction controle si la date a  controler est dans le futur par rapport a  la date du jour
*/
function controleDate(idObjetJour, msgErreur, obligatoire) { // + param4 optionnel : controlePostDateJour
    var controlePostDateJour = false;
    if (arguments.length > 3) // Si on a passe un argument supplementaire, il s'agit de controlePostDateJour
        controlePostDateJour = arguments[3];

    var resultat = true;
    var jour = document.getElementById(idObjetJour).value;
    //On trouve la chaine "Jour" et on la remplace par Mois et Annee
    var idObjetMois = idObjetJour.replace("Jour", "Mois");
    var idObjetAnnee = idObjetJour.replace("Jour", "Annee");
    var idObjetDatepicker = idObjetJour.replace("Jour", "Date");
    console.log(idObjetDatepicker);

    var mois = document.getElementById(idObjetMois).value;
    var annee = document.getElementById(idObjetAnnee).value;

    //Dans le cas ou obligatoire est false, on regarde si au moins un champ a ete saisi
    if (obligatoire == false) {
        var chaineJour = jour + "";
        var chaineMois = mois + "";
        var chaineAnnee = annee + "";
        if ((chaineJour.length > 0) | (chaineMois.length > 0) | (chaineAnnee.length > 0))
            obligatoire = true; // si au moins un champ a ete saisi, on passe obligatoire a  true pour executer les tests
    }

    if (obligatoire == true) {
        // Les valeurs sont-elles des nombres ?
        if ((isNaN(jour)) | (isNaN(mois)) | (isNaN(annee)))
            resultat = false;

        // L'annee est-elle sur 4 chiffres ?
        var chaineAnnee = annee + ""
        if ((resultat == true) & (chaineAnnee.length < 4))
            resultat = false;

        if (resultat == true) {
            var dateGeneree = new Date(annee, mois - 1, jour);
            // On compare la date generee avec la date saisie
            resultat = ((dateGeneree.getDate() == jour) && (dateGeneree.getMonth() == mois - 1) && (dateGeneree.getFullYear() == annee));
        }
    } //fin du cas obligatoire

    if ((resultat == true) & (controlePostDateJour == true)) // si controlePostDateJour est actif, on verifie que la date saisie n'est pas dans le futur (date du jour incluse)
    {
        var dateJour = new Date();
        if (dateGeneree > dateJour)
            resultat = false;
    }

    if (resultat == false) {
        marquerErreur(idObjetDatepicker, true);
        return msgErreur;
    } else {
        marquerErreur(idObjetDatepicker, false);
        return "";
    }
}

/* Cette fonction controle le nombre de caractères saisis
Si le nombre de caractères saisis est supérieur au nombre passé en paramètre la fonction retourne le message d'erreur. */
function controleLongueurObjet(idObjet, msgErreur, tailleMaxValide) {
    marquerErreur(idObjet, false);
    var resultat = true;
    idObjet = '#' + idObjet;

    if ($(idObjet).val().length > tailleMaxValide) {
        resultat = false;
    }

    if (resultat == false) {
        marquerErreur(idObjet, true);
        return msgErreur;
    } else return "";
}

/* Controle si la liste deroulante est en position 0 ou si l'input text est vide
Si l'objet controle est vide, la fonction retourne le message d'erreur passe en libelle, sinon rien */
function controleObjet(quelObjet, msgErreur) {

    var objet = document.getElementById(quelObjet);
    var resultat = true;

    if (objet != null) {
        switch (objet.type.toLowerCase()) {
            case 'email':
            case 'tel':
            case 'text':
                marquerErreur(quelObjet, false);
                if (objet.value.length == 0) {
                    resultat = false;
                    marquerErreur(quelObjet, true);
                }
                break;

            case 'number':
                marquerErreur(quelObjet, false);
                if (parseInt($(objet).val()) < parseInt($(objet).prop('min')) || parseInt($(objet).val()) > parseInt($(objet).prop('max'))) {
                    resultat = false;
                    marquerErreur(quelObjet, true);
                }
                break;

            case 'password':
                marquerErreur(quelObjet, false);

                if (objet.value.length == 0) {
                    resultat = false;
                    marquerErreur(quelObjet, true);
                }
                break;

            case 'select-one':
                marquerErreur(quelObjet, false);

                if (objet.selectedIndex == 0 && objet.value == '0') {
                    resultat = false;
                    marquerErreur(quelObjet, true);
                }
                break;

            case 'file':
                marquerErreur(quelObjet, false);

                if (objet.value.length == 0) {
                    resultat = false;
                    marquerErreur(quelObjet, true);
                }
                break;

            /* Dans le cas d'un bouton radio, on recupere l'attribut "name", qui contrairement a  l'attribut id n'est pas unique.
            On peut donc boucler sur tous les elements dont "name" est egal au "name" de l'objet passe en argument et verifier si au moins
            l'un d'entre eux est checked
            */
            case 'radio':
                var leName = objet.name;
                var objetsRadio = new Array();
                objetsRadio = document.getElementsByName(leName);
                var nbElements = objetsRadio.length;
                var compteur = 0;
                var objetChecked = false;
                while ((compteur < nbElements) & (objetChecked == false)) {
                    objetChecked = objetsRadio[compteur].checked;
                    compteur++;
                }
                resultat = objetChecked;
                break;
        }// fin switch
    }
    if (resultat == false)
        return msgErreur;
    else
        return "";
}


/* Controle la validite de la valeur saisie (texte, numerique)
typeVar='1' : controle si le champ ne contient que des lettres
typeVar='2' : controle si le champ ne contient que des chiffres
typeVar='3' : controle si le champ ne contient que des chiffres + indicateur "+" pour numero tel/fax
typeVar='4' : controle si le champ ne contient que des caracteres autorises pour email
typeVar='5' : controle si le champ ne contient que des chiffres et est supérieur à 0
typeVar='6' : controle si le champ ne contient que des chiffres à l'exclusion de tout autre caractère et supérieur à 0
Si erreur de typage, la fonction retourne le message d'erreur passe en libelle, sinon rien */
function controleValiditeObjet(quelObjet, msgErreur, typeVar) {
    if (document.getElementById(quelObjet).value != "") {
        var objet = document.getElementById(quelObjet);
        var resultat = true;
        marquerErreur(quelObjet, false);
        if (objet != null) {
            switch (objet.type.toLowerCase()) {
                case 'text':
                case 'tel':
                case 'email':
                    if (objet.value.length == 0) {
                        resultat = false;
                        marquerErreur(quelObjet, true);
                    }

                    if (typeVar != undefined) {
                        switch (typeVar) {
                            // controle si le champ ne contient que des lettres et pas de point
                            case '1':
                                var regexp = new RegExp("[0-9]");
                                if (regexp.test(objet.value) == true) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                }
                                break;

                            // controle si le champ ne contient que des chiffres
                            case '2':
                                var regexp = new RegExp("[a-zA-Z]");
                                if (regexp.test(objet.value) == true) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                }
                                break;

                            // controle si le champ ne contient que des chiffres + indicateur "+" pour numero tel/fax
                            case '3':
                                var regexp = new RegExp("^[0-9\+][-|\/\.\ ]?([0-9])([-|\/\.\ ]?[0-9]{1,}){1,}$");
                                if (regexp.test(objet.value) == false) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                }
                                break;

                            // controle si le champ ne contient que des caracteres autorises pour email
                            case '4':
                                var regexp = new RegExp("^[a-zA-Z0-9_\\-\\.]{1,}@[a-zA-Z0-9_\\-\\.]{2,}\\.[a-zA-Z]{2,}$", "g");
                                if (regexp.test(objet.value) == false) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                }
                                break;

                            // controle si le champ ne contient que des chiffres et est supérieur à 0
                            case '5':
                                var regexp = new RegExp("[a-zA-Z]");
                                if (regexp.test(objet.value) === true) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                } else { // la valeur ne contient que des chiffres, on teste la valeur positive non nulle
                                    if (parseFloat(objet.value) <= 0) {
                                        resultat = false;
                                        marquerErreur(quelObjet, true);
                                    }
                                }

                                break;

                            //controle si le champ ne contient que des chiffres à l'exclusion de tout autre caractère (regex plus stricte) et supérieur à 0
                            case '6':
                                var regexp = new RegExp("[^0-9]", 'g');
                                if (regexp.test(objet.value) === true) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                } else { // la valeur ne contient que des chiffres, on teste la valeur positive non nulle
                                    if (parseFloat(objet.value) <= 0) {
                                        resultat = false;
                                        marquerErreur(quelObjet, true);
                                    }
                                }

                                break;

                            // controle si le champ contient que des lettres et les caractères "-" et "'"
                            case '7':
                                var regexp = new RegExp("^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ '-]*$");
                                if (regexp.test(objet.value) == false) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                }
                                break;

                            // controle si 3 lettres identiques se suivent
                            case '8':
                                var regexp = new RegExp("(\\w)\\1{2,}", "g");
                                if (regexp.test(objet.value) == true) {
                                    resultat = false;
                                    marquerErreur(quelObjet, true);
                                }
                                break;

                            default:
                                break;
                        }
                    }

                    break;
            }// fin switch
        }
        if (resultat == false) {
            return msgErreur;
        } else {
            return "";
        }

    } else {
        return "";
    }
}

function generationValeurAleatoire() {
    //return Math.floor((new Date()).getTime() / 1000);
    return Math.floor((new Date()).getTime());
}

/* Fonction particuliere qui permet de trier les objets sur leur tabindex
Ne pas appeler directement mais avec la fonction sort().
Exemple : tableauObjets.sort(AutoTabulationTrierObjetsParTabIndex);
*/
function AutoTabulationTrierObjetsParTabIndex(a, b) {
    if (a.tabIndex < b.tabIndex)
        return -1;
    if (a.tabIndex > b.tabIndex)
        return 1;
    return 0;
}

/* Place le focus sur l'objet de type "input" ayant le tabindex suivant ou alors sur l'objet passe en 3eme parametre.
Exemple d'appel generique : AutoTabulation(this , event); ou AutoTabulation(this , event, 'idObjetSuivant');
Attention : les valeurs de tabIndex doivent etre renseignees pour les input concernes.
Les tabindex ne sont pas obligatoirement consecutifs : par exemple si le tabindex suivant 5 est 12,
la fonction place le focus sur le champ 12.
Le focus n'est deplace que si :
  - la valeur maxlength du champ courant est renseignee,
  - le contenu du champ a une longueur egale au maxlength
*/
function AutoTabulation(objet, evenement, idObjetSuivant, vbActivationTabulAutoSurDate) {

    if (vbActivationTabulAutoSurDate == 1) {

        // touche a  ignorer : tab et shift+tab
        var TAB = 9;
        var SHIFTTAB = 16;
        var longueurSaisie = 0;
        var longueurMax = 0;
        var codeTouche = 0;
        // recuperation de la touche pressee
        if (evenement != null)
            codeTouche = evenement.keyCode;

        if (objet != null) {
            longueurMax = objet.maxLength;
            longueurSaisie = objet.value.length
        }

        if ((longueurMax > 0) && (longueurSaisie == objet.maxLength) && (codeTouche != 0) && (codeTouche != TAB) && (codeTouche != SHIFTTAB)) {
            var tableauListeInput = new Array();

            if (arguments.length > 2) {
                var objetSuivant = document.getElementById(idObjetSuivant);
                if (objetSuivant != null) {
                    tableauListeInput.push(objetSuivant);
                }
            } else {
                var tabIndexCourant = objet.tabIndex;
                // Recuperation des elements de type input dans un objet de type nodeList
                var listeInput = new Array();
                listeInput = document.getElementsByTagName('input');
                // on ne peut pas utiliser la nodeList listeInput telle quelle (pour le tri ci-apres), on recopie les objets dans un tableau d'objets

                for (var compteur = 0; compteur < listeInput.length; compteur++) {
                    if (listeInput[compteur].tabIndex > tabIndexCourant)
                        tableauListeInput.push(listeInput[compteur]);
                }
                // tri des objets selon la valeur de leur tabindex
                tableauListeInput.sort(AutoTabulationTrierObjetsParTabIndex);
            }

            // on recupere le premier element du tableau, qui est l'element suivant a  utiliser
            if (tableauListeInput.length > 0) {
                tableauListeInput[0].focus();
                tableauListeInput[0].select();
            }
        }
    } else {
        return true;
    }
}

// Ajouter le texte passé en paramètre dans la liste des erreurs de la div d'erreurs
// Retourne "true" si le texte passé en paramètre a une longueur non nulle, ce qui permet
// de détecter la présence de messages d'erreur
function ajouterErreur(texte) {
    if (texte.length > 0) {
        texte = "<li>" + texte + "</li>";
        $("#listeErreurs").append(texte);
        return true;
    }
    return false;
}

// Ajouter le texte passé en paramètre dans la liste des messages de la div d'information.
function ajouterInformation(texte) {
    var msg = "<li>" + texte + "</li>";
    if (texte.length > 0 && $("#listeInformations").html().indexOf(msg) == -1) {
        $("#listeInformations").append(msg);
        showElement("#zoneInformation");
        return true;
    }
    return false;
}

// Affichage de la boîte de dialogue "veuillez patienter"
// vtTitreFenetre : si une chaine est passée, elle sera utilisée comme titre de fenêtre, sinon le titre par défaut est appliqué
function affichageMessageAttente(vtTitre) {
    var vtTitreFinal = ((vtTitre != undefined) && (vtTitre.length > 0)) ? vtTitre : "Chargement en cours...";
    $('#divChargementLabel').html(vtTitreFinal);

    showElement('#divChargement');
}

// Affichage de la boîte de dialogue "veuillez patienter" avec un délai
var messageAttenteTimeout = null;
function affichageMessageAttenteDelai(vtTitreDelai) {
    var delai = 300;
    var titre = null;

    if(typeof vtTitreDelai === "number")
        delai = vtTitreDelai;
    else if(typeof vtTitreDelai !== "undefined")
        titre = vtTitreDelai;

    // Attente de 300 ms
    messageAttenteTimeout = setTimeout(function(){
        affichageMessageAttente(titre);
    }, delai);
}

// Cache le message d'attente
function cacherMessageAttente() {
    if(messageAttenteTimeout !== null)
        clearTimeout(messageAttenteTimeout);

    $('#divChargement').on('shown.bs.modal', function(){
        hideElement('#divChargement');
    });
    hideElement('#divChargement');
}

/* Passe en disabled+readOnly tous les champs de formulaire "select" et "input" appartenant au conteneur "vtIdConteneur"
 * Sauf les champs hidden, et sauf ceux dont l'id ou le name sont contenus dans la chaine vtChaineElementsExclus (séparateur libre)*/
function verrouiller(vtIdConteneur, vtChaineElementsExclus) {
    $(document).ready(function(){
        // récupération de tous les input (non hidden) et les select appartenant au conteneur
        var toListeInput = $("#" + vtIdConteneur + " input[type!='hidden'], #" + vtIdConteneur + " select");
        $.each(toListeInput, function () {
            // si le nom n'est pas dans la liste des exclusions
            if (vtChaineElementsExclus.indexOf(this.name) == -1 || vtChaineElementsExclus.indexOf(this.id) == -1) {
                // Si l'id est vide OU si l'id est renseigné et absent des exclusions
                if ((this.id.length == 0) || (this.id.length > 0)) {
                    if (this.id.includes('-switch')) {
                        $(this).parent().addClass('disabled');
                        // Affichage de l'input sélectionné en multi-switch
                        if ($(this).parent().hasClass("btn-outline-primary") && $(this).parent().hasClass("active")) {
                            $(this).parent().removeClass('btn-outline-primary');
                            $(this).parent().addClass('btn-primary');
                        }
                    } else {
                        $(this).prop('readonly', true);
                    }
                    $(this).prop('disabled', true);
                }
            }
        });//each
    });
}

/*
 * Fonction d'affichage de la div passée en paramètre en boite de dialogue Bootstarp
 * nomCalque = div correspondant à la boîte à afficher
 * velLargeur et velHauteur : dimensions en px
 * vtTitre = titre de la fenêtre
 * (vbModal) : facultatif : indique si la fenêtre doit être modale. Vrai par défaut
 * (vbBody) : facultatif : indique si la fenêtre doit être à la fin de la balise body
 * (shown) : facultatif : Exécute la fonction shown après affichage de la modale
*/
function affichageDialogueBT(nomCalque, vtTitre, vbModal, vbBody, shown) {
    var vbModalApplicable = (vbModal != undefined) ? vbModal : true;
    var maModal = $('#' + nomCalque);

    // Est-ce que l'on doit les mettre à la fin du body pour les sortir de leur container
    if (vbBody && !maModal.data('body')) {
        maModal.data('body', true).detach().appendTo($('body'));
    }

    maModal.modal({
        title: vtTitre,
        modal: vbModalApplicable,
        closeOnEscape: false
    });

    shownModal = function () {
        initTooltip(maModal);
        initAutocompleteCodePostal();

        if(typeof shown === "function")
            shown();
    };

    maModal.off('shown.bs.modal').on('shown.bs.modal', shownModal);

    return maModal;
}

function fermerDialogueBT(nomCalque) {
    $('#' + nomCalque).modal('hide');
}

// Pour l'activation/désactivation des champs de saisie
// IdObjet = id de l'objet
// vbActif = true pour activer, false pour désactiver
function switchActivation(vtIdObjet, vbActif) {
    var vbDesactiver = !vbActif; //Pour simplifier les affectations de "disabled"
    $("#" + vtIdObjet).prop('disabled', vbDesactiver);
}


// Surcharge de la fonction window.open afin de détecter le blocage de popups
window.openSurchargee = window.open;
window.open = function (url, nom, proprietes) {
    if (nom != undefined || proprietes != undefined)
        var fenetre = window.openSurchargee(url, nom, proprietes);
    else
        var fenetre = window.openSurchargee(url);

    if (!fenetre) {
        alert("Un problème est survenu lors de l'ouverture de la fenêtre, veuillez vérifier l'anti-pop de votre navigateur :\n\n - Internet explorer : Outils\\Bloqueur de fenêtres publicitaires\\Toujours autoriser les fenêtres publicitaires de ce site...\n\n - Firefox : Sur le bandeau \"Firefox a empêché ce site d'ouvrir une fenêtre popup\" cliquez sur le bouton Options et sur Autoriser les popup pour ...\n\n - Safari : Préférences\\décocher \"Bloquer les fenêtres surgissantes\"");
    } else
        return fenetre;
};


// Crée ou modifie le cookie nommé "nom" avec la valeur "valeur", d'une durée de vie de n "jours"
// Passer une valeur vide dans "jours" crée un cookie qui sera effacé à la fermeture du navigateur
function createCookie(nom, valeur, jours) {
    if (jours) {
        var date = new Date();
        date.setTime(date.getTime() + (jours * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = nom + "=" + valeur + expires + "; path=/";
}

function readCookie(nom) {
    var nomCookie = nom + "=";
    var tableauCookies = document.cookie.split(';');
    for (var i = 0; i < tableauCookies.length; i++) {
        var unCookie = tableauCookies[i];
        while (unCookie.charAt(0) == ' ')
            unCookie = unCookie.substring(1, unCookie.length);
        if (unCookie.indexOf(nomCookie) == 0) return unCookie.substring(nomCookie.length, unCookie.length);
    }
    return null;
}

function eraseCookie(nom) {
    createCookie(nom, "", -1);
}

function debuterTelechargementFichier() {
    affichageMessageAttente("Veuillez patienter");
    createCookie('telechargementFichierEnCours', '1', "");
    attenteTelechargementFichier = setInterval("attenteTelechargement()", 500);
}


function attenteTelechargement() {
    if (readCookie('telechargementFichierEnCours') == '0') {
        clearInterval(attenteTelechargementFichier);
        cacherMessageAttente();
    }
}

// Redirige le partenaire sur l'intranet April - April ON
function demarrerRedirectionAprilON(velIdSimulation, velIdPersonne, velIdTarif, vtType, vbPromptAjoutCoEmp) {

    var openPromptAjoutCo = $(".openPromptAjoutCoEmp").val();
    var velAjoutCoEmp;

    if (vbPromptAjoutCoEmp == 1 && openPromptAjoutCo == 1) {
        $('#btnAprilAjouterCoemprunteur').on('click', function () {
            velAjoutCoEmp = 1;
            $(".openPromptAjoutCoEmp").val(0);
            redirectionAprilON(velIdSimulation, velIdPersonne, velIdTarif, vtType, velAjoutCoEmp);
            fermerDialogueBT("april_confirm_coempr");
        });
        $('#btnAprilNon').on('click', function () {
            velAjoutCoEmp = 0;
            $(".openPromptAjoutCoEmp").val(0);
            redirectionAprilON(velIdSimulation, velIdPersonne, velIdTarif, vtType, velAjoutCoEmp);
            fermerDialogueBT("april_confirm_coempr");
        });
        affichageDialogueBT('april_confirm_coempr');
    } else {
        redirectionAprilON(velIdSimulation, velIdPersonne, velIdTarif, vtType, 0);
    }

}

function redirectionAprilON(velIdSimulation, velIdPersonne, velIdTarif, vtType, velAjoutCoEmp) {

    affichageMessageAttente("Veuillez patienter");
    $("#messageErreur").hide();
    $("#messageErreur > .alert > div").text('');

    $.ajax({
        type: "POST",
        url: "/Partenaires/aprilon",
        dataType: "json",
        data: {
            velIdSimulation: velIdSimulation,
            velIdPersonne: velIdPersonne,
            velIdTarif: velIdTarif,
            ajoutCoEmp: velAjoutCoEmp
        },
        success: function (reponse) {
            //je contourne le "randomValue"
            let tab = window.open('about:blank', '_blank');
            tab.location = reponse.data.url;
            tab.focus();
        },
        error: function (xhr, ajaxOptions, thrownError) {
            let jsonError = JSON.parse(xhr.responseText);
            $("#zoneErreurs > div").text(jsonError.data.message);
        },
        complete: function () {
            cacherMessageAttente();
        }
    });
}

function html_entity_decode(message) {
    return message.replace(/[<>'"]/g, function(m) {
        return '&' + {
            '\'': 'apos',
            '"': 'quot',
            '&': 'amp',
            '<': 'lt',
            '>': 'gt',
        }[m] + ';';
    });
}

function choixTypeProposition() {
    affichageDialogueBT("boiteDialogueChoixTypeProposition");
}
